import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/LinkedAccountProvider/LinkedAccountProvider.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import ExternalLinkSvg from 'icons/external-link.svg'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

export type LinkedAccountProviderProps = {
  accountInfo: MixedAccountsTableItem
  hideIcon: boolean
}

export const LinkedAccountProvider: FC<LinkedAccountProviderProps> = (props) => {
  const { accountInfo, hideIcon } = props
  const { providerInfo, type, account } = accountInfo
  const { providerLogo, providerUrl, providerName } = providerInfo
  const category = account && account.category || null

  const url = providerUrl || `http://www.google.com/search?q=${ providerName }+login&btnI`
  const isStatusCard = providerName === 'Status Cards'
  const imageChild = useMemo(() => {
    if (hideIcon) {
      return null
    }
    if (providerLogo) {
      return (
        <a
          href={ url }
          target={ isStatusCard ? '_self' : '_blank' }
          title={ providerName }
          className={ styles.logo }
          style={{
            backgroundImage: `url(${ providerLogo })`,
          }}
        />
      )
    }

    const image = category ? require(`icons/${ category }.svg`).default : ''
    return (
      <div className={ styles.logoCategory }>
        <SvgIcon src={ image } />
      </div>
    )

  }, [hideIcon, providerLogo, category, url, isStatusCard, providerName])

  const title = type !== 'manual'
    ? (
      <a
        href={ url }
        target={ isStatusCard ? '_self' : '_blank' }
        title={ providerName }
      >
        { providerName }
        <div className={ styles.externalLinkIcon }>
          <SvgIcon src={ ExternalLinkSvg } />
        </div>
      </a>
    )
    : (
      <div>{ providerName }</div>
    )

  return (
    <div className={ styles.LinkedAccountProvider }>
      { imageChild }
      { title }
    </div>
  )
}
